import { logoPrincipal } from '../assets';

import FotoNaty from '../assets/images/Foto_Naty.PNG';
import FotoSanty from '../assets/images/Foto_Santy.PNG';

export default function Team() {
  const team = [
    {
      name: 'Edison Gómez',
      role: 'Director Académico & Desarrollo Estratégico',
      image: FotoSanty,
    },
    {
      name: 'Nataly Huertas',
      role: 'CEO & Arquitecta del Ecosistema Digital',
      image: FotoNaty,
    },
  ];

  return (
    <section className="py-20 relative bg-[#F8FAFC] dark:bg-slate-950 overflow-hidden" id="team">
      <div className="absolute inset-0 w-full h-full opacity-10 dark:opacity-[0.06] pointer-events-none">
        <div className="absolute top-0 left-0 w-full h-full bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] mix-blend-multiply dark:mix-blend-normal" />
      </div>

      {/* ✅ logoPrincipal como mosaico (repetido) */}
      <div
        className="absolute inset-0 pointer-events-none z-0 opacity-[0.06] dark:opacity-[0.10]"
        style={{
          backgroundImage: `url(${logoPrincipal})`,
          backgroundRepeat: 'repeat',
          // mismo “tamaño” aproximado al object-contain+scale(1.25) anterior
          backgroundSize: '420px 420px',
          backgroundPosition: 'center',
          filter: 'grayscale(1) contrast(1.05)',
        }}
      />

      <div className="absolute inset-0 bg-white/10 dark:bg-black/20 pointer-events-none z-0" />

      <div className="absolute top-1/4 right-0 w-[500px] h-[500px] bg-[#3662E2]/5 dark:bg-[#3662E2]/10 blur-[100px] rounded-full" />
      <div className="absolute bottom-1/4 left-0 w-[500px] h-[500px] bg-[#3662E2]/5 dark:bg-[#3662E2]/10 blur-[100px] rounded-full" />

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="text-center mb-20">
          
          <h2 className="text-5xl md:text-7xl font-display font-bold text-secondary dark:text-slate-100 tracking-tight uppercase">
            Mentes Detrás <br />
            <span className="text-white">
              Del Éxito
            </span>
          </h2>

          <p className="text-slate-500 dark:text-slate-300 mt-6 font-light text-lg max-w-2xl mx-auto">
            Detrás de cada marca que crece hay un equipo que sabe lo que hace. Nos encargamos de diseñar el camino para que tu negocio avance, venda más y se posicione con fuerza.
          </p>
        </div>

        <div className="flex justify-center">
          <div className="w-full max-w-5xl">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 place-items-center">
              {team.map((member, idx) => (
                <div
                  key={idx}
                  className="
                    group relative h-[420px] w-full max-w-[340px]
                    rounded-[2rem] overflow-hidden
                    border border-[#3662E2]/10 dark:border-slate-700/50
                    bg-white dark:bg-slate-900
                    transition-all duration-500
                    hover:scale-[1.02] hover:shadow-xl hover:shadow-[#3662E2]/10 hover:border-[#3662E2]/30
                  "
                >
                  <div
                    className="absolute inset-0 bg-cover bg-center transition-all duration-700 photo-filter"
                    style={{ backgroundImage: `url('${member.image}')` }}
                  />

                  <div className="absolute inset-0 bg-black/0 dark:bg-black/30 transition-colors duration-500" />

                  <div className="absolute inset-0 z-30 flex flex-col justify-end p-6">
                    <div className="transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500 delay-100 bg-white/80 dark:bg-slate-950/70 backdrop-blur-md p-4 rounded-2xl border border-white/50 dark:border-slate-700/60 shadow-lg text-center">
                      <h3 className="text-2xl font-display font-bold text-secondary dark:text-slate-100 mb-0.5">
                        {member.name}
                      </h3>

                      <p className="text-[#3662E2] font-medium text-xs tracking-wider uppercase mb-3 flex items-center justify-center gap-2">
                        <span className="w-1.5 h-1.5 bg-[#3662E2] rounded-full animate-pulse" />
                        {member.role}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

              </div>
    </section>
  );
}